
export default class GLobalPkm {
    static mapSvg = new Map<string, string>();
    static defaultBytes32 = '00000000-0000-0000-0000-000000000000'
}
